import { render, staticRenderFns } from "./ClientPicker.vue?vue&type=template&id=4d985efc&scoped=true&"
import script from "./ClientPicker.vue?vue&type=script&lang=js&"
export * from "./ClientPicker.vue?vue&type=script&lang=js&"
import style0 from "./ClientPicker.vue?vue&type=style&index=0&id=4d985efc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d985efc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VLayout,VTextField})
